(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PragaModalCtrl', PragaModalController);

  PragaModalController.$inject = [
    '$scope',
    'pragas',
    'preSelected',
    'MessagesService',
    'TiposOcorrenciasService'
  ];


  // eslint-disable-next-line max-lines-per-function, max-params
  function PragaModalController($scope, pragas, preSelected, MessagesService, TiposOcorrenciasService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.pragas = pragas;
    vm.selected = preSelected || [];
    vm.filter = null;
    vm.tipo = null;
    vm.tiposOcorrencias = TIPOS_OCORRENCIA;
    vm.limit = 10;

    //////////////////////////////////////////
    // Bindable methods
    vm.close = close;
    vm.toggle = toggle;
    vm.save = save;
    vm.filterPragasTipo = filterPragasTipo;
    vm.filterPragasDescricao = filterPragasDescricao;
    vm.pragaSelected = pragaSelected;


    //////////////////////////////////////////
    // Function declarations

    function filterPragasTipo() {
      const params = {
        tipo: vm.tipo,
        noPaginate: true
      };

      vm.filter = '';
      params.descricao = vm.filter;

      filterPragas(params);
    }

    function filterPragasDescricao() {
      const params = {
        tipo: vm.tipo,
        noPaginate: true
      };

      if (vm.filter && vm.filter.length > 3) {
        params.descricao = vm.filter;
        filterPragas(params);
      } else if (!vm.filter) {
        filterPragas(params);
      }
    }


    function filterPragas(params) {
      TiposOcorrenciasService.list(params).then(function(data) {
        vm.pragas = data.data || [];
      })
        .catch(function(error) {
          console.error('Erro ao buscar praga', error);
          MessagesService.alert('Erro ao carregar praga');
        })
        .finally(function() {
          vm.loadingPragas = false;
        });
    }

    function pragaSelected(praga) {
      return _.find(vm.selected, {
        id: praga.item_id || praga.item_codigo || praga.id || praga.cd_item
      });
    }

    function close() {
      $scope.$dismiss();
    }

    function toggle(praga) {
      return vm.pragaSelected(praga) ? vm.selected.splice(vm.selected.indexOf(praga), 1) : vm.selected.push(praga);
    }

    function save() {
      return $scope.$close(vm.selected);
    }
  }
}());
